import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class IncidentService {

    
    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }


    getTasksByTemplateId(templateId) {
        return this._http.get(environment.serverUrl + '/taskTemplate/tasks/' + templateId);
    }

    performPagination(templateId, pageNumber, formType, displayFieldKey) {
        let header: any = this._capEngineService.getHeaders('viewTaskList');
        header.params = { formType: formType, displayFieldKey: displayFieldKey };

        // tslint:disable-next-line:max-line-length
        return this._http.get(environment.serverUrl + '/task/' + templateId + '/tasks/pagination/' + pageNumber, header);
    }

    getFilteredTasks(dataObj, pageNumber) {
        let header: any = this._capEngineService.getHeaders('viewTaskList');
        header.params = dataObj;
        return this._http.get(environment.serverUrl + '/tasks/getFilteredTasks/' + pageNumber, header);
    }

    getTasksOnSearch(searchString, templateId, pageNumber, isHazardForm) {

        let header: any = this._capEngineService.getHeaders('viewTaskList');
        header.params = { isHazardForm: isHazardForm };

        // tslint:disable-next-line:max-line-length
        return this._http.get(environment.serverUrl + '/task/search/' + searchString + '/template/' + templateId + '/pagination/' + pageNumber, header);
    }

    downloadMultipleCSV(Obj) {
        return this._http.post(environment.serverUrl + '/task/downloadMultiplePdf', Obj, { responseType: 'blob' });
    }

    downloadLHoistCSV(Obj) {
        return this._http.post(environment.serverUrl + '/lhoist/excel', Obj, { responseType: 'blob' });
    }
    
    downloadMultiplePdf(Obj) {
        return this._http.post(environment.serverUrl + '/task/downloadtaskpdfs', Obj, { responseType: 'blob' });
    }

    downloadAuthentication(password) {
        return this._http.post(environment.serverUrl + '/user/verifyPassword', password);
    }
}



// WEBPACK FOOTER //
// ./src/app/incidents/incidents.service.ts